import React, { FC, useState, useEffect } from 'react';
import { ButtonPrimary } from '../../../components-v2/shared';

export interface AddEmailFormProps {
    onAdd: (email: string) => Promise<boolean>;
    loading: boolean;
    disabled?: boolean;
}

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const AddEmailForm: FC<AddEmailFormProps> = ({ onAdd, loading, disabled }) => {
    const [email, setEmail] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        if (success) {
            const timer = setTimeout(() => setSuccess(false), 3000);
            return () => clearTimeout(timer);
        }
        return undefined;
    }, [success]);

    const validateEmail = (value: string): boolean => {
        if (!value.trim()) {
            setError('Email address is required');
            return false;
        }
        if (!EMAIL_REGEX.test(value.trim())) {
            setError('Please enter a valid email address');
            return false;
        }
        setError(null);
        return true;
    };

    const handleAdd = async () => {
        if (!validateEmail(email)) {
            return;
        }

        const result = await onAdd(email.trim().toLowerCase());

        if (result) {
            setEmail('');
            setError(null);
            setSuccess(true);
        }
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && !disabled && !loading) {
            handleAdd();
        }
    };

    return (
        <div className="add-email-form">
            <div className="add-email-form__inputs">
                <input
                    type="email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    onKeyPress={handleKeyPress}
                    placeholder="Enter email address"
                    disabled={disabled || loading}
                    className="add-email-form__input"
                />
                <ButtonPrimary onClick={handleAdd} disabled={disabled || loading || !email.trim()}>
                    {loading ? 'Adding...' : 'Add to Blocklist'}
                </ButtonPrimary>
            </div>
            {error && <div className="add-email-form__error">{error}</div>}
            {success && <div className="add-email-form__success">Email added to blocklist successfully</div>}
        </div>
    );
};
